import { motion } from "framer-motion";

import galleryImg8 from "../../assets/images/gallery/galleryImg8.jpeg";
import galleryImg10 from "../../assets/images/gallery/galleryImg10.jpeg";
import galleryImg13 from "../../assets/images/gallery/galleryImg13.jpeg";
import galleryImg14 from "../../assets/images/gallery/galleryImg14.jpeg";
import galleryImg15 from "../../assets/images/gallery/galleryImg15.jpeg";
import heroImage from "../../assets/images/hero-image-12.jpg";

export default function StudioSection() {
  return (
    <section
      id="about"
      className="relative bg-[#f2f2f2] py-32 overflow-hidden"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* DARK OVERLAY (background only) */}
      <div className="absolute inset-0 bg-[#0e202b]/95 z-0" />

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 grid lg:grid-cols-[1fr_1.3fr] gap-16 items-start">

        {/* ================= LEFT CONTENT ================= */}
        <div className="space-y-8 max-w-xl">
          <div className="inline-flex items-center gap-2 bg-white/10  px-6 py-2 rounded-full text-sm text-white w-fit">
            Built for Adventure
          </div>

          <h2 className="text-[3.5rem] font-bold leading-tight text-white">
            The Studio.
          </h2>

          <p className="text-lg text-gray-300">
            A creative expedition studio shaping routes, stories, and unforgettable mountain experiences.

          </p>
        </div>

        {/* ================= RIGHT MASONRY ================= */}
      <div className="grid grid-cols-2 gap-6">
  <StudioCard
    large
    name="From Concept to Summit"
    role="The Beginning of Every Journey"
    img={galleryImg8}
    description="Every adventure starts here with planning, exploration, and a deep understanding of the mountains we move through."
  />

  <StudioCard
    name="Route Intelligence"
    role="Mapped with Purpose"
    img={galleryImg10}
    description="Carefully designed routes that balance challenge, safety, and unforgettable views."
  />

  <StudioCard
    name="Visual Storytelling"
    role="Moments That Last"
    img={galleryImg15}
    description="Capturing raw landscapes and real moments that define the BroadBoy adventure experience."
  />

  <StudioCard
    name="Expedition Craft"
    role="Refined in the Wild"
    img={galleryImg14}
    description="Gear choices, timing, and logistics shaped by real mountain conditions."
  />

  <StudioCard
    name="Adventure Philosophy"
    role="Our Way of the Mountains"
    img={galleryImg13}
    description="Respect the mountains. Move with intention. Leave nothing behind but footprints."
  />
</div>

      </div>
    </section>
  );
}

/* ================= Studio CARD ================= */

function StudioCard({ name, role, img, description, large }) {
  return (
    <div
      className={`relative rounded-[20px] overflow-hidden shadow-lg group
        ${large ? "row-span-2 h-full" : "h-[260px]"}`}
    >
      <img
        src={img}
        alt={name}
        className="absolute inset-0 w-full h-full object-cover scale-[1.05]"
      />

      {/* Hover Overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Hover Content */}
      <div
        className={`absolute inset-0 z-10 p-6 h-full flex flex-col justify-between text-white
          opacity-0 translate-y-4
          group-hover:opacity-100 group-hover:translate-y-0
          transition-all duration-300`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">{name}</h3>
            <p className="text-sm opacity-80">{role}</p>
          </div>
        </div>

        <p className={`text-sm leading-relaxed ${large ? "max-w-xs" : "max-w-[90%]"}`}>
          {description}
        </p>
      </div>
    </div>
  );
}
